import { defineStore } from "pinia";
import { ref } from "vue";

import { apiClient } from "@/client";
import {
	type ComplianceUpdate,
	PublicReport,
	type PublicReportComplianceCreateRequest,
	type PublicReportDTO,
	type PublicReportUpdate,
} from "@/type/api";

export const useStorePublicReport = defineStore("rmo-publicreport", () => {
	// State
	const byID = ref<Map<string, PublicReport>>(new Map());
	const byURI = ref<Map<string, PublicReport>>(new Map());
	const loading = ref(false);
	const ongoingFetches = ref<Map<string, Promise<PublicReport> | null>>(
		new Map(),
	);

	function add(pr: PublicReport) {
		byID.value.set(pr.public_id, pr);
		byURI.value.set(pr.uri, pr);
	}
	async function createCompliance(
		data: PublicReportComplianceCreateRequest,
	): Promise<PublicReport> {
		const resp = (await apiClient.JSONPost(
			"/api/rmo/compliance",
			data,
		)) as PublicReportDTO;
		const result = PublicReport.fromJSON(resp);
		byID.value.set(result.public_id, result);
		byURI.value.set(result.uri, result);
		return result;
	}
	async function fetchByID(id: string): Promise<PublicReport> {
		let uri = "/api/rmo/publicreport/" + id;
		return fetchByURI(uri);
	}
	async function fetchByURI(uri: string): Promise<PublicReport> {
		loading.value = true;
		try {
			const body = (await apiClient.JSONGet(uri)) as PublicReportDTO;
			const report = PublicReport.fromJSON(body);
			byID.value.set(report.public_id, report);
			byURI.value.set(report.uri, report);
			return report;
		} catch (err) {
			console.error("Error loading users:", err);
			throw err;
		}
	}
	async function update(
		uri: string,
		updates: PublicReportUpdate | ComplianceUpdate,
	): Promise<PublicReport> {
		const resp = (await apiClient.JSONPut(uri, updates)) as PublicReportDTO;
		return PublicReport.fromJSON(resp);
	}
	return {
		// Actions
		add,
		byID,
		byURI,
		createCompliance,
		fetchByID,
		fetchByURI,
		update,
	};
});
